import React from "react";
import styles from "./ContactInfo.module.css";
import { BsInstagram, BsFacebook, BsPinterest } from "react-icons/bs";
import { Icons } from "../Icons/Icons";

function ContactInfo() {
  return (
    <div className={styles.contact}>
      <p className={styles.text}>
        Suelo ser activa en redes sociales, te invito a seguirme y podés
        enviarme un DM cuando quieras. Me encataría conocerte.
      </p>
      <div className={styles.icons}>
        <Icons
          text={"La red social que más uso"}
          icon={<BsInstagram></BsInstagram>}
          href="https://www.instagram.com/pawpawneedle/"
          user="pawpawneedle"
        ></Icons>
        <Icons
          text="Mi alternativa de comunicación"
          icon={<BsFacebook></BsFacebook>}
          href="https://www.facebook.com/pawpawneedle"
          user="pawpawneedle"
        ></Icons>
        <Icons
          text="Encontrá inspiración"
          icon={<BsPinterest></BsPinterest>}
          href="https://pin.it/4r0f0KX"
          user="pawpawneedle"
        ></Icons>
      </div>
    </div>
  );
}

export { ContactInfo };
